// Body load opacity
$(window).on('load', function () {
  setTimeout(function () {
    $('body').animate({ opacity: 1 }, 900);
    $('#marquee_wrapper svg').css('width', 'auto');
  }, 500);

  setTimeout(function () {
  $('.announcement-barrow').prependTo('.header-row');
   }, 100);
});

$(document).ready(function () {
   
  $('.announcement_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    vertical: false,
    fade: true,
    autoplay: true,
    speed: 1500,
  });
});

// Search open
$('.icon-search-link').on('click', function () {
  $('.search-header').slideToggle('fast');
  $('.search-header__input').focus();
});

// Sub navigation menu hover change image
$('.subnav-links li').on('mouseover', function () {
  var navimg = $(this).attr('id');
  $('.nav_imgbox ').removeClass('active');
  $('#' + navimg + '_div').addClass('active');
});

// Header add class on scroll
$(window).scroll(function () {
  if ($(this).scrollTop() > 100) {
    $('.header-row').addClass('dark_header');
  } else {
    $('.header-row').removeClass('dark_header');
  }
});

// Mobile menu click
$('.mo_menulink').on('click', function () {
  $('#SiteNav').slideToggle('fast');
  $('.header-row').toggleClass('header_black');
  $(this).toggleClass('active');
  $(this).text(function (i, v) {
    return v === 'Menu' ? 'Close' : 'Menu';
  });
});

$(document).on('click', '.mobile-content .site-nav--has-dropdown > a', function () {
  if ($(this).closest('li').hasClass('active')) {
    $(this).parents('ul').find('li').removeClass('active');
  } else {
    $(this).parents('ul').find('li').removeClass('active');
    $(this).parent('li').addClass('active');
  }
});

function handleDropdownToggle() {
  if ($(window).width() < 1200) {
    $('ul.site-nav').addClass('mobile-content');
    $('.custom-header-height').addClass('stop-hover');
  } else {
    $('ul.site-nav').removeClass('mobile-content');
    $('.custom-header-height').removeClass('stop-hover');
  }
}

window.addEventListener('resize', function () {
  handleDropdownToggle();
});
handleDropdownToggle();

$(document).on('click', '#added-box .close_box', function () {
  $('.overlay_wrapper').click();
});
